import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import Hero from './components/Hero';
import BlogContent from './components/BlogContent';
import FAQSection from './components/FAQSection';
import BottomCTA from './components/BottomCTA';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://popprotents.com';

const blogListJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Blog',
  '@id': `${siteUrl}/blog/#blog`,
  name: 'Pop Pro Tents Blog — Stretch Tent Guides & Inspiration',
  url: `${siteUrl}/blog`,
  description: 'Expert guides on stretch tent rentals, event planning, tent sizing, fabric comparisons, and real-world case studies from Austin Texas and beyond.',
  publisher: {
    '@type': 'Organization',
    '@id': `${siteUrl}/#business`,
    name: 'Pop Pro Tents',
  },
  blogPost: [
    {
      '@type': 'BlogPosting',
      headline: 'Suitable Stretch Tent Sizes for Your Outdoor Event',
      url: `${siteUrl}/blog/suitable-stretch-tent-sizes-for-your-outdoor-event`,
    },
    {
      '@type': 'BlogPosting',
      headline: 'Stretch Tent Rentals Guide — Tips & Considerations',
      url: `${siteUrl}/blog/stretch-tent-rentals-guide-tips-considerations`,
    },
    {
      '@type': 'BlogPosting',
      headline: 'Lightning in a Bottle Festival — Stretch Tent Showcase',
      url: `${siteUrl}/blog/lightning-in-a-bottle-festival`,
    },
    {
      '@type': 'BlogPosting',
      headline: 'Enhance Festival Appeal with Stretch Tents',
      url: `${siteUrl}/blog/enhance-festival-appeal-stretch-tents`,
    },
    {
      '@type': 'BlogPosting',
      headline: 'Luxury Bedouin Tents for Exclusive Events',
      url: `${siteUrl}/blog/luxury-bedouin-tents-exclusive-events`,
    },
    {
      '@type': 'BlogPosting',
      headline: 'Behind the Scenes — Pop Pro Tents',
      url: `${siteUrl}/blog/behind-the-scenes-pop-pro-tents`,
    },
    {
      '@type': 'BlogPosting',
      headline: 'Festival Stretch Tent for Outdoor Music Festival',
      url: `${siteUrl}/blog/festival-stretch-tent-outdoor-music-festival`,
    },
    {
      '@type': 'BlogPosting',
      headline: '10 Reasons to Choose a Stretch Tent for Your Next Event',
      url: `${siteUrl}/blog/10-reasons-choose-stretch-tent-next-event`,
    },
    {
      '@type': 'BlogPosting',
      headline: 'Our Stretch Tent Fabrics Outperform Other Fabrics',
      url: `${siteUrl}/blog/our-stretch-tent-fabrics-outperform-other-fabrics`,
    },
  ],
};

export default function BlogPage() {
  return (
    <div className="min-h-screen bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(blogListJsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <BlogContent />
        <div id="faq" className="scroll-mt-24">
          <FAQSection />
        </div>
        <BottomCTA />
      </main>
      <Footer />
    </div>
  );
}